"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_rank__professor__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "rank_professor_hi_dark",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 115.82,
    y1: 1296.71,
    x2: 138.45,
    y2: 1319.34,
    gradientTransform: "translate(0 -1195.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162,114H69.8a10,10,0,0,1-9.9-9.9V39.9A10,10,0,0,1,69.8,30H162a10,10,0,0,1,9.9,9.9v64.2A9.92,9.92,0,0,1,162,114Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.6,108.8H71.2a9.35,9.35,0,0,1-9.3-9.3V41.3A9.35,9.35,0,0,1,71.2,32h89.4a9.35,9.35,0,0,1,9.3,9.3V99.5A9.28,9.28,0,0,1,160.6,108.8Z",
    style: {
      fill: "#4a4d4e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,111H69.8a10,10,0,0,1-9.9-9.9v3a10,10,0,0,0,9.9,9.9H162a10,10,0,0,0,9.9-9.9v-3A9.92,9.92,0,0,1,162,111Z",
    style: {
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6,139.9a2.93,2.93,0,0,1-1.9-.8,2.66,2.66,0,0,1,0-3.7L123,92.3a2.62,2.62,0,0,1,3.7,3.7L83.5,139.2A2.64,2.64,0,0,1,81.6,139.9Z",
    style: {
      fill: "#e60000"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 91.5,
    r: 23.6,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,113.1A23.65,23.65,0,0,1,34.4,90.5v1a23.6,23.6,0,0,0,47.2,0v-1A23.65,23.65,0,0,1,58,113.1Z",
    style: {
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b2ca7fa1-619f-45ca-903c-57092e202b64",
    d: "M90,158.7a7.36,7.36,0,0,0,5.7-8.8c0-.1-.1-.2-.1-.4C89.7,126,73.8,115,58.1,115s-31.9,11-37.9,34.5a7.48,7.48,0,0,0,5.3,9.1c.1,0,.3.1.4.1A157.55,157.55,0,0,0,58,162,155.86,155.86,0,0,0,90,158.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,156.7A155.62,155.62,0,0,1,58.1,160,156.83,156.83,0,0,1,26,156.7c-.1,0-.3-.1-.4-.1a7.37,7.37,0,0,1-5.4-6.1,7.36,7.36,0,0,0,5.4,8.1c.1,0,.3.1.4.1A157.55,157.55,0,0,0,58.1,162,155.62,155.62,0,0,0,90,158.7a7.44,7.44,0,0,0,5.8-8.3A7.22,7.22,0,0,1,90,156.7Z",
    style: {
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.5,92.1,148.4,114H108.6l18-18a2.66,2.66,0,0,0,0-3.7Z",
    style: {
      opacity: 0.200000002980232,
      isolation: "isolate",
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.9,68.9c-4.2,4.2,3.2,4.8,8,0s6.6-2.6,4,0,.3,3.7,4,0,.1,7.9,8,0,4.7,3.3,8,0,4,0,4,0",
    style: {
      fill: "none",
      stroke: "#f4f4f4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.3,82.1c.5,1.6,1.4,3,5.7-1.3,7.9-7.9,4.7,3.3,8,0s4,0,4,0",
    style: {
      fill: "none",
      stroke: "#f4f4f4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}

var _default = ic_rank__professor__dark;
exports.default = _default;